/**
 * Сервис для работы с инвайтами (приглашениями)
 */

import api from './api'

export const invitesService = {
	/**
	 * Создать инвайт
	 */
	async create({ email, role = 'teacher', expiresInDays = 7, maxUses = 1, note }) {
		const response = await api.post('/invites', {
			email,
			role,
			expiresInDays,
			maxUses,
			note
		})
		return response.data
	},

	/**
	 * Получить список инвайтов
	 */
	async getAll({ page = 1, limit = 20, status = 'all' } = {}) {
		const response = await api.get('/invites', {
			params: { page, limit, status }
		})
		return response.data
	},

	/**
	 * Валидация токена (публичный)
	 */
	async validate(token, email = null) {
		const params = email ? { email } : {}
		const response = await api.get(`/invites/validate/${token}`, { params })
		return response.data
	},

	/**
	 * Удалить инвайт
	 */
	async delete(id) {
		const response = await api.delete(`/invites/${id}`)
		return response.data
	}
}

export default invitesService
